import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const config = {
  theme: {
    themes: {
      light: {
        primary: '#3589CD', // #E53935
        secondary: '#1A1F35', // #FFCDD2
        error: '#f44336',
        info: '#3589CD',
        success: '#529c60',
        warning: '#d08c28',
        // accent: colors.indigo.base, // #3F51B5
      }
    }
  }
}

export default new Vuetify(config)
